import { useState, useEffect } from "react";

import Spinner from "../../spinners/DataSpinner";

import axios from "axios";

import { Link, useNavigate, useParams } from "react-router-dom";
import swal from "sweetalert";

const ViewProducts = () => {

    const { slug } = useParams();

    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [category, setCategory] = useState([]);
    const [products, setProducts] = useState([]);

    const productCount = products.length;


    useEffect(() => {
        let isMounted = true;
        axios.get(`api/get-products/${slug}`)
            .then(res => {
                if (isMounted) {
                    if (res.data.status === 200) {
                        setProducts(res.data.product_data.products);
                        setCategory(res.data.product_data.category);
                        setLoading(false);
                    }
                } else if (res.data.status === 400) {
                    swal("Warning", res.data.message, "error");
                    navigate("/collections");
                }
            });

        return () => {
            isMounted = false;
        }

    }, []);

    if (loading) {
        return <Spinner />
    } else {
        var productList = "";
        if (productCount) {
            productList = products.map((item) => {
                return (
                    <div className="col" key={item.id}>
                        <div className="card shadow-sm border-0">
                            <div className="card-body">
                                <Link to={`/collections/${item.category.slug}/${item.slug}`}>
                                    <img className="img-fluid rounded d-block m-auto" src={`${process.env.REACT_APP_API_URL}/public/uploads/products/${item.image}`} alt={`${item.name}`} />
                                </Link>
                                <h2 className="card-text text-center mb-3 mt-3">{item.name}</h2>
                                <div className="d-flex justify-content-center align-items-center">
                                    <Link className="btn btn-md btn-primary" to={`/collections/${item.category.slug}/${item.slug}`}>
                                        View Products
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            });
        } else {
            productList =
                <div className="col-lg-12">
                    <p className="alert alert-info text-center">No Product Was Found!</p>
                </div>
        }
    }
    return (
        <div className="album py-5 bg-light">
            <div className="container">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/">Home</Link>
                        </li>
                        <li className="breadcrumb-item active">
                            <Link to='/collections'>Collections</Link>
                        </li>
                        <li className="breadcrumb-item">
                            {category.name}
                        </li>
                    </ol>
                </nav>
                <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
                    {productList}
                </div>
            </div>
        </div>
    );
}

export default ViewProducts;